export const safeCaptcha = async (
  execute: (action: string) => Promise<string>,
  action: string
) => {
  try {
    return await execute(action)
  } catch (e) {
    console.warn(e)
    console.log(JSON.stringify(e))
    return null
  }
}
